import AreaPicker from "@/components/AreaPicker";
import { Input } from "@/components/Input";
import { makePlatformOnClick } from "@/components/utils";
import { Form, Image } from "antd-mobile";
import { FormContentProps } from ".";
import { cn } from "@/libs";
import styles from "../index.module.scss";

export const DigitalRMBForm = (props: FormContentProps) => {
  return (
    <>
      <Form.Item label="姓名" name={"realName"}>
        <Input placeholder="请输入姓名" />
      </Form.Item>
      <Form.Item label="所在地区" name={"area"}>
        <AreaPicker placeholder="请选择" />
      </Form.Item>
      <Form.Item label="数字人民币收款地址" name={"digitalAddress"}>
        <Input placeholder="请输入数字人民币收款地址" />
      </Form.Item>
      <Form.Item label="资金密码" name={"securePassword"}>
        <Input
          type={"password"}
          placeholder="6位纯数字资金密码"
          autoComplete="new-password"
        />
      </Form.Item>
      <Form.Item
        className={cn(styles.imageCodeForm)}
        label="验证码"
        name={"code"}
        extra={
          <div
            {...makePlatformOnClick((e) => {
              e.preventDefault();
              props.flushCodeImage();
            })}
          >
            <Image className={cn(styles.imageCode)}  src={props.codeImage} alt="code" />
          </div>
        }
      >
        <Input placeholder="图片验证码" autoComplete="new-password" />
      </Form.Item>
    </>
  );
};
